import React from 'react';
import { FileListData } from '@typings/ResidentTypes';
import UploadMultiDocuments from '@components/UploadMultiDocuments';
import '../styles.scss';
import UploadedFileTable from '@components/UploadedFileTable';

interface UploadAdvanceCarePlanProps {
  userId: string;
  fileList: FileListData[];
  setFileList: (fileList: any) => void;
}

const UploadAdvanceCarePlan: React.FC<UploadAdvanceCarePlanProps> = ({
  userId,
  fileList,
  setFileList,
}) => {
  return (
    <div className="upload-acp">
      <div className="govuk-form-group mt-2 govuk-bp:mt-5">
        <label className="govuk-label" htmlFor="file-upload-1">
          <h3 className="govuk-heading-s">
            Please upload a copy of relevant documents when available.
          </h3>
          <UploadMultiDocuments
            userId={userId}
            fileList={fileList}
            setFileList={setFileList}
            uploadInputId="file-upload-1"
          />
        </label>
      </div>

      {fileList.length > 0 && (
        <div>
          <h3 className="govuk-heading-m">
            Previous Advance Care Plans and relevant files
          </h3>
          <UploadedFileTable fileList={fileList} setFileList={setFileList} />
        </div>
      )}
    </div>
  );
};

export default UploadAdvanceCarePlan;
